import React, { useEffect, useRef, useState } from 'react';
import PhoneAnimationService, { AnimationStyles } from '../../utils/PhoneAnimationService';
import '../../styles/components/HomeSection/AnimatedPhoneMockup.css';

const AnimatedPhoneMockup: React.FC = () => {
  const [animationStyles, setAnimationStyles] = useState<AnimationStyles>({
    topLeftRectStyle: { opacity: 0 },
    topRightRectStyle: { opacity: 0, transform: 'translate(0px, 0px)' },
    bottomRectStyle: { opacity: 0, transform: 'translate(0px, 0px) rotate(0deg)' },
  });
  
  const animationServiceRef = useRef<PhoneAnimationService | null>(null);
  const animationFrameRef = useRef<number | null>(null);

  useEffect(() => {
    animationServiceRef.current = new PhoneAnimationService();
    
    let lastTime = 0;
    const targetFPS = 60;
    const frameInterval = 1000 / targetFPS;
    
    const animate = (currentTime: number) => {
      if (currentTime - lastTime >= frameInterval) {
        if (animationServiceRef.current) {
          const styles = animationServiceRef.current.getAnimationStyles();
          setAnimationStyles(styles);
        }
        lastTime = currentTime;
      }
      animationFrameRef.current = requestAnimationFrame(animate);
    };
    
    animationFrameRef.current = requestAnimationFrame(animate);
    
    const startAnimation = async () => {
      if (animationServiceRef.current) {
        // Start the infinite animation
        animationServiceRef.current.startAnimation();
      }
    };
    
    const timer = setTimeout(startAnimation, 1000);
    
    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className="phone-mockup">
      <div className="phone-screen splash-screen">
        <div className="app-title">RushHour</div>
        
        <div className="logo-container">
          <div className="top-row">
            <div 
              className="rectangle top-left"
              style={animationStyles.topLeftRectStyle}
            />
            <div 
              className="rectangle top-right"
              style={animationStyles.topRightRectStyle}
            />
          </div>
          
          <div className="bottom-row">
            <div 
              className="rectangle bottom"
              style={animationStyles.bottomRectStyle}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnimatedPhoneMockup;
